module.exports = __webpack_public_path__ + "img/logojabatan.de400f1a.png";